import {EventEmitter, Injectable} from '@angular/core';
import {ICardDataViewModel} from '../shared/models/models';

@Injectable()
export class CardListItemClickService {
    public static $name = 'cardListItemClickService';
    public cardClickedEvent = new EventEmitter<ICardDataViewModel>();
}
